import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Company, GetTotalsResponse, GetTotalInput, GetQuestionsResponse, PolicyDetail, GetRamiVitaResponse, GetRiskLevelsResponse, DirectSearchAPIInput, SearchAPIResponse, FavoriteItem, GetSimilarProductsInput, SimilarProducts, SaveItem } from 'models';
import { Observable, firstValueFrom, isObservable, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { BrowserConfig } from 'src/_services';
import { StorageService } from 'src/_services/storage.service';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class ApiService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(
    private http: HttpClient,
    private storage: StorageService
  ) { }

  /**
   * (GET) API to retrieve the list of Questions for the "Guided Search"
   * 
   * @returns getQuestionsResponse
   */
  public _getQuestions(): Observable<GetQuestionsResponse> {
    const getUrl = `${BrowserConfig.apiBaseDomain}/comparatore/questionario`;
    return this.http.get<GetQuestionsResponse>(getUrl)
      .pipe(
        map(
          (response: GetQuestionsResponse) => {
            return response;
          })
      );
  }
  public async getQuestions(): Promise<GetQuestionsResponse> {
    const getUrl = `${BrowserConfig.apiBaseDomain}/comparatore/questionario`;
    return firstValueFrom(this.http.get<GetQuestionsResponse>(getUrl))
  }

  public getPolicy(fidaCode: string, bgColor: string = '' , txtColor: string = ''): Observable<PolicyDetail> {
    return this.http.get<PolicyDetail>(`${BrowserConfig.apiBaseDomain}/comparatore/dettaglio/${fidaCode}?bgCoor=${bgColor}&txtColor=${txtColor}`)
  }
  /**
   * (GET) API to retrieve the list of Questions for the "Guided Search"
   * 
   * @returns getQuestionsResponse
   */
  public getCompanies(): Observable<Company[]> {
    const getUrl = `${BrowserConfig.apiBaseDomain}/comparatore/compagnie`;
    return this.http.get<Company[]>(getUrl)
      .pipe(
        map(
          (response: Company[]) => {
            this.storage.setCompanies(response)
            return response;
          })
      );
  }

  /**
   * (POST) API to retrieve the total products of each answer
   * 
   * @param input 
   * @returns 
   */
  public getTotals(input: GetTotalInput): Observable<GetTotalsResponse> {
    const postUrl = `${BrowserConfig.apiBaseDomain}/comparatore/ricerca/totali`;

    return this.http.post<any>(postUrl,input)
    .pipe(
      map(
        (response: any) => {
          return response;
        }
      )
    );

  }

  public async postTotals(input: GetTotalInput): Promise<GetTotalsResponse> {
    const postUrl = `${BrowserConfig.apiBaseDomain}/comparatore/ricerca/totali`;
    return firstValueFrom(this.http.post<GetTotalsResponse>(postUrl, input))
  }

  /**
   * 
   * @returns 
   */
  public getRamiVita(): Observable<GetRamiVitaResponse[]> {
    const getUrl = `${BrowserConfig.apiBaseDomain}/comparatore/ramivita`;
    return this.http.get<GetRamiVitaResponse[]>(getUrl)
      .pipe(
        map(
          (response: GetRamiVitaResponse[]) => {
            return response;
          })
      );
  }

  /**
   * 
   * @returns 
   */
  public getRiskLevels(): Observable<GetRiskLevelsResponse[]> {
    const getUrl = `${BrowserConfig.apiBaseDomain}/comparatore/rischiosita`;
    return this.http.get<GetRiskLevelsResponse[]>(getUrl)
      .pipe(
        map(
          (response: GetRiskLevelsResponse[]) => {
            return response;
          })
      );
  }

  /**
   * (POST) API per avere la lista dei prodotti dalla ricerca diretta
   * 
   * @param input 
   * @returns 
   */
  public _getProductDS(input: DirectSearchAPIInput): Observable<SearchAPIResponse> {
    const postUrl = `${BrowserConfig.apiBaseDomain}/comparatore/ricerca/prodotti`;

    return this.http.post<SearchAPIResponse>(postUrl,input)
    .pipe(
      map(
        (response: SearchAPIResponse) => {
          return response;
        }
      )
    );
  }

  public async getProductsDS(input: DirectSearchAPIInput): Promise<SearchAPIResponse> {
    const postUrl = `${BrowserConfig.apiBaseDomain}/comparatore/ricerca/prodotti`;

    return firstValueFrom(this.http.post<SearchAPIResponse>(postUrl,input))
  }

  /**
   * (POST) API per avere la lista dei prodotti dalla ricerca diretta
   * 
   * @param input 
   * @returns 
   */
  public getGuidedSearchResults(input: GetTotalInput): Observable<SearchAPIResponse> {
    const postUrl = `${BrowserConfig.apiBaseDomain}/comparatore/ricerca/lista`;

    return this.http.post<SearchAPIResponse>(postUrl,input)
    .pipe(
      map(
        (response: SearchAPIResponse) => {
          return response;
        }
      )
    );

  }

  public async postSurveyResults(input: GetTotalInput): Promise<SearchAPIResponse> {
    const postUrl = `${BrowserConfig.apiBaseDomain}/comparatore/ricerca/lista`;
    return firstValueFrom(this.http.post<SearchAPIResponse>(postUrl,input))
  }

  public async getFavorites(): Promise<FavoriteItem[]> {
    const getUrl = `${BrowserConfig.apiBaseDomain}/comparatore/utenti/preferiti`;
    return firstValueFrom(await this.http.get<FavoriteItem[]>(getUrl))
  }

  public async AddToFavorites(input: FavoriteItem): Promise<any> {
    const putUrl = `${BrowserConfig.apiBaseDomain}/comparatore/utenti/preferiti/${input.Id}`;
    return firstValueFrom(await this.http.put<any>(putUrl, input))
  }

  public async DeleteFromFavorites(fId: number): Promise<any> {
    const deleteUrl = `${BrowserConfig.apiBaseDomain}/comparatore/utenti/preferiti/${fId}`;
    return firstValueFrom(await this.http.delete<any>(deleteUrl))
  }

  public async getSavedSurveys(): Promise<SaveItem[]> {
    const getUrl = `${BrowserConfig.apiBaseDomain}/comparatore/utenti/ricerche`;
    return firstValueFrom(await this.http.get<SaveItem[]>(getUrl))
  }
  
  public async getSavedSurveyById(surveyId: string): Promise<SaveItem> {
    const getUrl = `${BrowserConfig.apiBaseDomain}/comparatore/utenti/ricerche/${surveyId}`;
    return firstValueFrom(await this.http.get<SaveItem>(getUrl))
  }

  public async deleteSavedSurveyById(surveyId: string): Promise<any> {
    const deleteUrl = `${BrowserConfig.apiBaseDomain}/comparatore/utenti/ricerche/${surveyId}`;
    return firstValueFrom(await this.http.delete<any>(deleteUrl))
  } 

  public async saveSurvey(input: SaveItem): Promise<any> {
    const putUrl = `${BrowserConfig.apiBaseDomain}/comparatore/utenti/ricerche/${input.Id}`;
    return firstValueFrom(await this.http.put<any>(putUrl, input))
  }

  public async getKid(fidaCode: string): Promise<HttpResponse<Blob>> {
    const getUrl = `${BrowserConfig.apiBaseDomain}/comparatore/kid/${fidaCode}`;

    return firstValueFrom(this.http.get<Blob>(getUrl, {
      observe: 'response',
      responseType: 'blob' as 'json'
    }))
  }

  public getSimilarProducts(fidaCode: string, input: GetSimilarProductsInput): Observable<SimilarProducts> {
    const postUrl = `${BrowserConfig.apiBaseDomain}/comparatore/dettaglio/similari/${fidaCode}`;
    return this.http.post<SimilarProducts>(postUrl, input)
  }

}
